// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App'
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'
import store from './store'
import Toast, { TYPE } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(Vuex)
Vue.use(VueResource)
const toastOptions = {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 5,
  newestOnTop: true,
  toastDefaults: {
    // ToastOptions object for each type of toast
    [TYPE.ERROR]: {
      position: 'top-center',
      timeout: 2000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.6,
      showCloseButtonOnHover: true,
      hideProgressBar: false,
      closeButton: 'button',
      icon: true,
      rtl: false
    },
    [TYPE.SUCCESS]: {
      position: 'top-center',
      timeout: 2000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.6,
      showCloseButtonOnHover: true,
      hideProgressBar: false,
      closeButton: 'button',
      icon: true,
      rtl: false
    }
  }
}
Vue.use(Toast, toastOptions)
Vue.config.productionTip = false

require('font-awesome/css/font-awesome.css')
require('date-input-polyfill')

if (localStorage.getItem('access_token')) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token')
}

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

/* eslint-disable no-new */
let app = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

if (!process.env.NODE_ENV !== 'production') {
  Vue.config.devtools = true
  window.store = store
  window.router = router
  window.app = app
}



// WEBPACK FOOTER //
// ./src/main.js